import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default [{
  path: "/chatWindowAi",
  name: "chatWindowAi",
  component: function component() {
    return import("../../../views/ai-digital-human/chatWindowAi");
  },
  meta: {
    title: "AI客服",
    foot: true
  }
}];